import { AxiosError } from 'axios';
import { ApiPathParam } from 'web-library/models/SearchParamSchema';
import { TransactionLogResponseContentObject } from 'web-library/models/UserGroupAccessConfiguration/UserGroupAccessConfiguration';
import { GET_PROFILE_AMENDMENT_REQUEST_TRANSACTION_LOG_URL } from '../../constants/apiUrls';
import { GET_PROFILE_AMENDMENT_REQUEST_TRANSACTION_LOG_QUERY_KEY } from '../../constants/queryKeys';
import axiosClient from '../axiosClient';
import { useCustomQuery } from '../utils/useCustomQuery';
import { PaginatedData } from '../../models/List';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request / Response
// =============================================================================
interface Input {
  onSuccess?: (res: PaginatedData<TransactionLogResponseContentObject>) => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
  apiPathParam: ApiPathParam;
  uuid: string;
  enabled: boolean;
}

// =============================================================================
// Query
// =============================================================================
export const useGetProfileAmendmentRequestTransactionLog = ({
  apiPathParam,
  onError,
  onSuccess,
  uuid,
  enabled,
}: Input) => {
  const getProfileAmendmentRequestTransactionLog = async () => {
    const res = await axiosClient.get<PaginatedData<TransactionLogResponseContentObject>>(
      GET_PROFILE_AMENDMENT_REQUEST_TRANSACTION_LOG_URL(uuid, apiPathParam)
    );
    return res.data;
  };

  return useCustomQuery(
    GET_PROFILE_AMENDMENT_REQUEST_TRANSACTION_LOG_QUERY_KEY,
    getProfileAmendmentRequestTransactionLog,
    {
      onSuccess,
      onError,
      enabled,
    }
  );
};
